import { useState, useEffect } from 'react';
import { PlaceHolder } from './PlaceHolders';
import { Get } from '../../apis/Narratives';

export function NarrativePlaceholder({
  pkid,
  narrativeTypeCode,
  clientId,
  onLock,
  updateData,
  refresh,
}) {
  const [narr, setNarr] = useState(null);

  useEffect(() => {
    let isActive = true;
    if (pkid == "00000000-0000-0000-0000-000000000000") {
      setNarr({narrativeText: ""});
    }
    else {
      Get(pkid)
        .then(data => {
          if (isActive) setNarr(data);
        })
        .catch(err => {
          console.error(`Failed to load narrative ${narrativeTypeCode}`, err);
        });
    }
    return () => { isActive = false; };
  }, [pkid]);

  if (!narr) {
    return <div>Loading Narrative…</div>;
  }

  return (
    <PlaceHolder
      key={narr.pkid}
      data={narr}
      clientId={clientId}
      hasEdit={true}
      onLock={onLock}
      updateData={updateData}
      refresh={refresh}
      narrativeTypeCode={narrativeTypeCode}
    />
  );
}
